import DeleteAdditionalCostModal from './DeleteAdditionalCostModal.vue';

export default DeleteAdditionalCostModal;
